export enum TrackingEvent {
  Add = `[Annotations] Add Annotation`,
  Edit = `[Annotations] Edit Annotation`,
  Delete = `[Annotations] Delete Annotation`,
  Read = `[Annotations] Read Annotation`,
  Filter = `[Annotations] Filter Annotations`,
  Sort = `[Annotations] Sort Annotations`,
  Hide = `[Annotations] Hide Annotations`,
  Show = `[Annotations] Show Annotations`,
}

export enum TrackingEventProperty {
  ReportName = `Report name`,
  AnnotationTimestamp = `Annotation Timestamp`,
  AnnotationText = `Annotation Text`,
  AnnotationCount = `# of annotations`,
  AnnotationTagCount = `# of tags`,
  AnnotationTagNames = `Names of tags`,
  ShowUntagged = `Showing untagged annotations`,
  Location = `Annotation Location`,
}

export enum AnnotationLocation {
  Sidepanel = `sidepanel`,
  Chart = `chart`,
  Logbook = `logbook`,
}

type TrackingEventProperties = {
  [key in TrackingEventProperty]?: any;
};

export function track(event: TrackingEvent, properties: TrackingEventProperties) {
  mixpanel.track(event, properties);
}
